/**
 * Generic "cannot display" confirmation card (plan 05 B3, 2026-09-29).
 *
 * Shown for a `confirmation_request` whose (tool, schema_version) this client
 * has no card for, or whose proposal fails that card's model, and for any
 * restored card of an unrecognised kind. It never offers a confirm button:
 * nothing the person cannot see is ever submitted. The tool name is plain
 * text (React-escaped, never markdown) and length-capped.
 */
import React from 'react';
import { Paper, Typography } from '@mui/material';
import { capToolName } from '../../../utils/confirmationRequest';

/**
 * @param {object} props
 * @param {object} props.message - A `{type: 'confirmation', ...}` chat message.
 */
export default function UnsupportedCard({ message }) {
  const tool = capToolName(message && message.tool);

  return (
    <Paper
      className="il-assistant-bubble"
      variant="outlined"
      sx={{
        p: 2,
        maxWidth: '70%',
        borderRadius: '18px 18px 18px 4px',
        borderColor: 'divider',
        opacity: 0.7,
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        Action not shown
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This action can't be displayed, so it was not submitted.
      </Typography>
      {tool && (
        <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary', wordBreak: 'break-all' }}>
          Tool: {tool}
        </Typography>
      )}
    </Paper>
  );
}
